/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { DisplayHtmlContent, NeedToKnow as NeedToKnowSarsaparilla } from 'sarsaparilla';
import { ContentProps } from '../props/contents';
import NoFeePeriods from './activityPasses/NoFeePeriods';

export default class NeedToKnow extends PureComponent {
    static defaultProps = {
        checked: false,
        className: '',
        onChange: () => {},
        siteName: 'our site',
        needToKnow: [],
        showCheckbox: true,
        noFeePeriods: [],
        isInvalid: false,
    };

    static propTypes = {
        checked: PropTypes.bool,
        className: PropTypes.string,
        onChange: PropTypes.func,
        siteName: PropTypes.string,
        needToKnow: PropTypes.arrayOf(ContentProps),
        noFeePeriods: PropTypes.arrayOf(PropTypes.object),
        showCheckbox: PropTypes.bool,
        isInvalid: PropTypes.bool,
    };

    informationRef = React.createRef();

    componentDidMount() {
        const ref = this.informationRef.current;
        if (ref && ref.scrollHeight - ref.clientHeight <= 0) {
            ref.parentElement.classList = `${ref.parentElement.classList} no-scrollable-content`;
        }
    }

    render() {
        const {
            checked,
            className,
            showCheckbox,
            onChange,
            siteName,
            noFeePeriods,
            needToKnow,
            isInvalid,
        } = this.props;
        const introText = `Please carefully review the important information below ${
            showCheckbox
                ? 'and click the check box to agree to the rules and regulations'
                : ''
        }. The information in this section only pertains to your selection. Other important visitation policies and details can be found on the ${
            process.env.SITE_NAME
        } page for ${this.props.siteName}.`;

        return (
            <NeedToKnowSarsaparilla
                introText={introText}
                className={className}
                isChecked={checked}
                showCheckbox={showCheckbox}
                onChange={() => onChange(!checked)}
                isInvalid={isInvalid}
            >
                {needToKnow.map(({ title, paragraphs = [] }, i) => (
                    <section className="rec-order-detail-need-help" key={`section-${i}`}>
                        {!!title && (
                            <h3 className="activitypass-section-heading h6">{title}</h3>
                        )}
                        {paragraphs.map((html, n) => (
                            <DisplayHtmlContent
                                key={`html-${n}`}
                                html={`<p>${html}</p>`}
                            />
                        ))}
                    </section>
                ))}

                <NoFeePeriods siteName={siteName} noFeePeriods={noFeePeriods} />
            </NeedToKnowSarsaparilla>
        );
    }
}

// cspell:ignore activitypass
